import { wrap as withStyle } from 'utils/styles'

export default withStyle((props) => {
  const {
    cardSize: { width },
    theme: {
      color: { grey },
    },
  } = props

  return `
    width: ${width ? `${width}px` : '100%'};
    border-left: 1px solid ${grey};  
    border-right: 1px solid ${grey};  
    overflow-y: auto;
    overflow-x: hidden;
  `
})
